import template from "./configuration-list.html";
import controller from "./configuration-list.controller";
import "./configuration-list.scss";

const Component = {
	template,
	controller,
	controllerAs: "controller"
};

export default Component;


// WEBPACK FOOTER //
// ./sources/components/configurations/configuration-list/configuration-list.component.js